import type { ReactNode } from 'react';
import { useFeatureGate } from '@/entities/subscription';
import type { SubscriptionFeature } from '@/entities/subscription';
import { FeatureUpgradePrompt } from '@/widgets/feature-upgrade-prompt';

interface FeatureGateProps {
  children: ReactNode;
  feature: SubscriptionFeature;
  /** Rendered when the feature is gated and has no full-page upgrade prompt. */
  fallback?: ReactNode;
}

export const FeatureGate = ({ children, feature, fallback = null }: FeatureGateProps) => {
  const gate = useFeatureGate(feature);

  if (gate.enabled) {
    return <>{children}</>;
  }

  if (gate.featureGateKey) {
    return <FeatureUpgradePrompt requiredTier={gate.requiredTier} featureKey={gate.featureGateKey} />;
  }

  return <>{fallback}</>;
};
